import React, {useEffect, useState} from 'react';
import css from './Command.module.scss'
import friend1 from '../../../../images/friend1.png'
import friend2 from '../../../../images/friend2.png'
import friend3 from '../../../../images/friend3.png'
import friend4 from '../../../../images/friend4.png'
import CommandItem from "./CommandItem";
import {RemoveScrollBar} from "react-remove-scroll-bar";
import DeleteUser from "../../../common/modals/DeleteUser";
import {useTheme} from "../../../../App";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getTeam} from "../../../../redux/profile/profile-thunks";

const Command = ({isDark, team, user, getTeam}) => {
  const [deleteUser, setDeleteUser] = useState(null)
  const {t} = useTranslation()
  useEffect(() => {
    if(user) getTeam()
  }, [user])
  console.log(team)
  // const users = [
  //   {
  //     img: friend1,
  //     name: 'Ronald Richards',
  //     email: 'ronald_richards@gmail.com',
  //     trips: 3,
  //     comeTogether: '127 NM'
  //   },
  //   {
  //     img: friend2,
  //     name: 'Darrell Steward',
  //     email: 'darrell_steward@gmail.com',
  //     trips: 5,
  //     comeTogether: '278 NM'
  //   },
  //   {
  //     img: friend3,
  //     name: 'Jenny Wilson',
  //     email: 'jenny.wilson@gmail.com',
  //     trips: 2,
  //     comeTogether: '78 NM'
  //   },
  //   {
  //     img: friend4,
  //     name: 'Cameron Williamson',
  //     email: 'cameron.williamson@gmail.com',
  //     trips: 6,
  //     comeTogether: '321 NM'
  //   },
  //   {
  //     email: 'ronald_richards@gmail.com'
  //   },
  // ]
  return (
    <div className={`${css.commandWrapper} ${isDark && css.commandWrapper__dark}`}>
      <div style={{width: '920px'}}>
        <div className={css.command}>
          <ul className={css.command__row}>
            <li className={css.command__item}></li>
            <li className={css.command__item}>{t('name')}</li>
            <li className={css.command__item}>{t('email')}</li>
            <li className={css.command__item}>{t('commonTrips')}</li>
            <li className={css.command__item}>{t('sailedTogether')}</li>
          </ul>
          {team.map((user, index) => <CommandItem isDark={isDark}
                                                   setDeleteUser={() => setDeleteUser({...user})} user={user}/>)}
        </div>
      </div>
      {(deleteUser) && <>
        <RemoveScrollBar/>
        <div className="overlay"/>
        <DeleteUser username={deleteUser.name} closeModal={() => setDeleteUser(null)}/>
      </>}
    </div>
  );
};

const mapStateToProps = (state) => ({
  team: state.profileReducer.team,
  user: state.userReducer.user,
})

export default connect(mapStateToProps, {getTeam})(React.memo(Command));
